import React, { useEffect, useState } from "react";
import fetchData from "../../../api/fetchApi";
import Table from "../../common/Table";
import PageHeader from "../../common/PageHeader";
import { useParams, useNavigate } from "react-router-dom";
import ConfirmDeleteAlert from "../../common/ConfirmDeleteAlert";
// Simple edit modal
function EditUserModal({ open, onClose, onSave, user, loading }) {
  const [form, setForm] = useState(user || { name: "", email: "", phone: "", username: "" });
  const [error, setError] = useState(null);
  useEffect(() => { setForm(user || { name: "", email: "", phone: "", username: "" }); setError(null); }, [user, open]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <form onSubmit={async e => { e.preventDefault(); setError(null); await onSave(form, setError); }} className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center" dir="rtl">
        <div className="flex justify-end mb-2"><button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600"><svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button></div>
        <h2 className="text-2xl font-bold mb-4">تعديل المستخدم</h2>
        <input name="name" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} className="border rounded px-3 py-2 mb-2 w-full" placeholder="اسم المستخدم" required />
        <input name="username" value={form.username} onChange={e=>setForm(f=>({...f,username:e.target.value}))} className="border rounded px-3 py-2 mb-2 w-full" placeholder="اسم الدخول" required />
        <input name="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} className="border rounded px-3 py-2 mb-2 w-full" placeholder="البريد الإلكتروني" required type="email" />
        <input name="phone" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} className="border rounded px-3 py-2 mb-2 w-full" placeholder="الهاتف" />
        {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
        <div className="flex gap-2 justify-end mt-4">
          <button type="button" className="bg-gray-200 px-4 py-2 rounded" onClick={onClose}>إلغاء</button>
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded" disabled={loading}>{loading ? "جاري الحفظ..." : "حفظ"}</button>
        </div>
      </form>
    </div>
  );
}

export default function ResellerUsersPage() {
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchData(`finance/resellers/${id}/reseller-users`);
      setUsers(data.data || []);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [id]);

  const columns = [
    { header: "المعرف", accessor: "id" },
    { header: "الاسم", accessor: "name" },
    { header: "البريد الإلكتروني", accessor: "email" },
    { header: "الهاتف", accessor: "phone" },
    { header: "نشط؟", accessor: "is_active", render: row => row.is_active ? "نعم" : "لا" },
    { header: "تاريخ الإنشاء", accessor: "created_at" },
  ];

  // Actions for each row
  const act = [
    {
      label: "تعديل",
      onClick: (row) => setEditUser(row),
    },
    {
      label: deleteLoading ? "جاري الحذف..." : "حذف",
      onClick: (row) => setDeleteId(row.id),
      disabled: deleteLoading,
    },
  ];

  // Delete handler
  const handleDelete = async () => {
    if (!deleteId) return;
    setDeleteLoading(true);
    try {
      await fetchData(`finance/resellers/${id}/reseller-users/${deleteId}`, "DELETE");
      setDeleteId(null);
      fetchUsers();
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء الحذف");
    } finally {
      setDeleteLoading(false);
    }
  };

  // Edit handler
  const handleEditSave = async (form, setError) => {
    setEditLoading(true);
    setError && setError(null);
    try {
      await fetchData(`finance/resellers/${id}/reseller-users/${editUser.id}`, "PUT", form);
      setEditUser(null);
      fetchUsers();
    } catch (err) {
      setError && setError(err.message || "حدث خطأ أثناء التعديل");
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
     <PageHeader title="مستخدمو الموزع" total={
            users.length
           } stats={[]}>
               <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                 <span className="inline-block rotate-180">↕</span>
                 من الاحدث إلى الأقدم
               </button>
               
               <button
                 onClick={() => navigate(`/finance/resellers/${id}/reseller-users/new`)}
                 className="px-4 py-2.5 rounded-lg text-white bg-[var(--Primary-Primary)] shadow-sm text-sm md:text-base"
               >
                 إضافة مستخدم جديد
               </button>
             </PageHeader>
      
      <Table columns={columns} rows={users} pagination={false} act={act} />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
      <EditUserModal open={!!editUser} onClose={()=>setEditUser(null)} onSave={handleEditSave} user={editUser} loading={editLoading} />
      {deleteId && <ConfirmDeleteAlert
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        onConfirm={handleDelete}
        loading={deleteLoading}
        title="تأكيد حذف المستخدم"
        message="هل أنت متأكد أنك تريد حذف هذا المستخدم؟ لا يمكن التراجع عن هذا الإجراء."
      />}
    </div>
  );
}
